import { createRoot } from "react-dom/client";
import { ReactRoot } from "/src/ReactRoot.jsx";
import { reactiveMovieModel, reactiveLoginModel } from "./model/reactiveModel";

const rootJSX = <ReactRoot
    movieModel={reactiveMovieModel}
    loginModel={reactiveLoginModel}
/>
createRoot(document.getElementById('root')).render(rootJSX);